<template>
  <div class="research-development-basic-info-content">
    <div class="base-info-item">
      <div class="base-info-item-title">科研投入</div>
      <div>
        <span style="font-size: 3rem; font-weight: 700">{{
          scientificResearchInvestment
        }}</span>
        <span> 万元</span>
      </div>
    </div>
    <div class="base-info-item">
      <div class="base-info-item-title">科研项目</div>
      <div>
        <span style="font-size: 3rem; font-weight: 700">{{
          researchProject
        }}</span>
        <span> 个</span>
      </div>
    </div>
    <div class="base-info-item">
      <div class="base-info-item-title">专利总量</div>
      <div>
        <span style="font-size: 3rem; font-weight: 700">{{
          totalNumberOfPatents
        }}</span>
        <span> 个</span>
      </div>
    </div>
  </div>
</template>

<script>
import { ajax } from "@/config/ppm-request.js";
export default {
  name: "research-development-basic-info",
  data() {
    return {
      scientificResearchInvestment: "",
      researchProject: "",
      totalNumberOfPatents: "",
    };
  },
  mounted() {
    this.initData();
  },
  methods:{
    async initData(){
      const researchProject = await ajax.get("/zsck/bi/getAllProjectCount");
      this.researchProject = researchProject
      const scientificResearchInvestment = await ajax.get("/zsck/bi/getAllProjectCost");
      this.scientificResearchInvestment = scientificResearchInvestment
      const totalNumberOfPatents = await ajax.get("/zsck/bi/intelligenceProperty");
      this.totalNumberOfPatents = totalNumberOfPatents.patentQtt
    }
  }
};
</script>

<style lang="less" scope>
.research-development-basic-info-content {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  .base-info-item {
    word-wrap: break-word;
    word-break: break-all;
    overflow-wrap: break-word;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .base-info-item-title {
      position: relative;
      left: -5%;
    }
    &:nth-child(1) {
      width: 48%;
    }
    &:nth-child(2){
      width: 20%;
    }
    &:nth-child(3) {
      width: 32%;
    }
  }
}
</style>